<template>
	<div class="table-surface-loyer">
		<el-table :table="surface_loyer_table" variant="highlight-results" />
		<div class="box-edit left lefter" v-show="editor.mode == 'editing'">
			<div class="box-edit-line">
				<label>Nombre de lignes</label>
				<input
				type="range"
				v-model="surface_loyer_table_lines"
				min="1"
				max="5"
				step="1"
				/>
				<span class="value">{{ surface_loyer_table_lines }} lignes</span>
			</div>
		</div>
	</div>
</template>
<script>

import { mapGetters } from "vuex";
import number from "@/libs/number";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {

	mixins: [PageMixin],
	computed: {
		...mapGetters([
			"editor",
			"active_study"
		]),
		surface_loyer_table_lines: {
			get () {
				return parseInt(
					this.active_study.etudeData.gie.sectionCaracteristiquesResidence
						.surface_loyer_table_lines
				);
			},
			set (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.gie.sectionCaracteristiquesResidence,
					field: "surface_loyer_table_lines",
					value: value,
				});
			}
      
		},
		surface_loyer_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [15, 25, 25, 30],
				},
			};

			table.head.push(["Type", "Nb.", "Surf. hab.", "Loyer/m²"]);

			for (let i = 0; i < this.surface_loyer_table_lines; i++) {
				const loc = this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table[i];
				const loyer_m2 = loc.loyer_m2;

				const rows = [
					{ parent_data: loc, property: "type", editable: true },
					{ parent_data: loc, property: "nb", editable: true },
					{
						parent_data: loc,
						property: "surf_hab",
						editable: true,
						suffix: " m²",
					},
				];

				if (i == 0) {
					rows.push({
						value: number.format(loyer_m2, 1),
						parent_data:
              this.active_study.etudeData.gie.sectionCaracteristiquesResidence,
						property: "surface_loyer_loyer_m2",
						editable: true,
						suffix: " €",
						rowspan: this.surface_loyer_table_lines + 1,
					});
				}

				table.body.push(rows);
			}

			const total = { type: 0, nb: 0, surf_hab: 0, loyer_m2: 0 };
			for (let i = 0; i < this.surface_loyer_table_lines; i++) {
				const loc = this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table[i];
				const nb = number.clean(loc.nb);

				if (nb) {
					total.nb += number.clean(nb);
					total.surf_hab += number.clean(loc.surf_hab) * number.clean(nb);
					total.loyer_m2 += number.clean(loc.loyer_m2) * number.clean(nb);
				}
			}

			table.body.push([
				"Total/Moy.",
				total.nb,
				{ value: number.format(total.surf_hab / total.nb, 1), suffix: "m²" },
			]);

			return table;
		},
	}
};
</script>
<style lang="stylus" scoped>
@import '../../../../../../assets/css/app';
@import '../../../../../../assets/css/page';
</style>